import React from 'react';

const SidebarLayoutContext = React.createContext(null);
export default SidebarLayoutContext;
